export default "__VITE_ASSET__DENR7Spp__"